import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import Settings from './pages/Settings';
import Support2 from './pages/Support2';
import SignIn from './pages/auth/SignIn';
import SignUp from './pages/auth/SignUp';
import ForgotPassword from './pages/auth/ForgotPassword';
import ResetPassword from './pages/auth/ResetPassword';
import EmailVerification from './pages/auth/EmailVerification';
import TermsOfService from './components/TermsOfService';
import PrivacyPolicy from './components/PrivacyPolicy';

// Protected Route مدمج مباشرة
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    // عرض loading أثناء التحقق من حالة المصادقة
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    // حفظ المسار الحالي لتوجيه المستخدم إليه بعد تسجيل الدخول
    return <Navigate to="/signin" state={{ from: location.pathname }} replace />;
  }

  return children;
};

// Public Route مدمج مباشرة
const PublicRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

const AppRoutes = () => {
  const { user } = useAuth();

  return (
    <Routes>
      {/* الصفحة الرئيسية - توجيه تلقائي */}
      <Route 
        path="/" 
        element={
          <Navigate to="/dashboard" replace />
        } 
      />
      
      {/* صفحات المصادقة (للغير مسجلين فقط) */}
      <Route 
        path="/signin" 
        element={
          <PublicRoute>
            <SignIn />
          </PublicRoute>
        } 
      />
      
      <Route 
        path="/signup" 
        element={
          <PublicRoute>
            <SignUp />
          </PublicRoute>
        } 
      />
      
      <Route 
        path="/forgot-password" 
        element={
          <PublicRoute>
            <ForgotPassword />
          </PublicRoute>
        } 
      />
      
      <Route 
        path="/reset-password/:token" 
        element={
          <PublicRoute>
            <ResetPassword />
          </PublicRoute>
        } 
      />
      
      {/* صفحة التحقق من البريد - متاحة للجميع */}
      <Route 
        path="/verify-email" 
        element={<EmailVerification />} 
      />
      
      {/* المسارات المحمية */}
      <Route 
        path="/dashboard" 
        element={
          <ProtectedRoute>
            <Layout user={user} />
          </ProtectedRoute>
        } 
      >
        <Route index element={<Dashboard />} />
        <Route path="settings" element={<Settings />} />
        <Route path="support" element={<Support2 />} />
      </Route>

      {/* صفحات المعلومات العامة */}
      <Route path="/terms-of-service" element={<TermsOfService />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      
      {/* أي مسار غير موجود */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default AppRoutes;